export class CmdAction{
    actionType: string; 
    target: string;
}